import {
  deleteSupplier,
  getAllSuppliers,
  newSupplier,
  updateSupplier,
  getSupplier,
} from '../supplier-service';


export default {
  /**
   * Get all suppliers
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllSuppliers({ commit }) {
    const response = await getAllSuppliers();
    commit('setProperty', { property: 'suppliers', payload: response });
  },

  /**
   *
   * @param commit
   * @param supplierId
   * @returns {Promise<void>}
   */
  async deleteSupplier({ commit }, { supplierId }) {
    await deleteSupplier(supplierId);
    commit('delProperty', { property: supplierId });
  },

  /**
   *
   * @param context
   * @param supplierId
   * @param supplier
   * @returns {Promise<void>}
   */
  async updateSupplier(context, { supplierId, supplier }) {
    await updateSupplier(supplierId, supplier);
  },

  /**
   *
   * @param context
   * @param supplier
   * @returns {Promise<void>}
   */
  async newSupplier({ commit }, { supplier }) {
    const response = await newSupplier(supplier);
    commit('setNewSupplier', { payload: response });
    commit('setProperty', { property: 'supplier', payload: response });
  },

  /**
   *
   * @param context
   * @param supplierId
   * @returns {Promise<void>}
   */
  async getSupplier({ commit }, supplierId) {
    const response = await getSupplier(supplierId);
    commit('setProperty', { property: 'supplier', payload: response });
  },
};
